// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import VueCookies from 'vue-cookies'
import axios from 'axios';
import store from './assets/js/store'
import Utils from './assets/js/utils'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// 让ajax携带cookie
axios.defaults.withCredentials=true;
// 注册 axios 为全局变量
Vue.prototype.$axios = axios;
Vue.prototype.$utils = Utils;
// 使用 vue cookie
Vue.use(VueCookies)
//表示关闭 更多调试信息
Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(VideoPlayer)
Vue.use(ElementUI, {
  size: 'small'
});
//Vue.prototype.SERVER_API_URL = "http://139.196.97.153:8088";
//Vue.prototype.SERVER_API_URL = "http://localhost:8088";
//Vue.prototype.SERVER_API_URL = "http://192.168.0.108:8088";
Vue.prototype.SERVER_API_URL = "/api";

const i18n = new VueI18n({
  locale: 'zh',
  messages
});

Vue.config.errorHandler = function(err, vm, info) {
  console.log(`Error: ${err.toString()}\nInfo: ${info}`);
}

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {

  //先判断时否需要登录
  if (to.meta.requireAuth == true) {
    /*document.title = '${to.meta.title} | vue-manage-system';*/
    const role = JSON.parse(localStorage.getExpire('user'));
    console.log("username:" + role);
    if (!role) {
      if(to.meta.manageAuth){
        next('/manage/login');
      }else{
        next('/course/login');
      }
    } else if (to.meta.manageAuth) {
      let identity = role.identity;
      if (!identity) {
        next('/manage/login');
      }else{
        if (identity === 'program') {
          Vue.prototype.$alert('权限不足，无法进入管理系统', '权限不足通知', {
            confirmButtonText: '确定',
          }).then(() => {
            location.reload();
          });
          next('/');

        } else {
          // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
          if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
              confirmButtonText: '确定'
            });
          }
        }
      }
    }
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});
/*
new Vue（{
  render : h => h(App), //渲染app组件
}）.$mount('#app') //如果所有工作完毕，最终挂载到id=app中显示
* */



// WEBPACK FOOTER //
// ./src/main.js